/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
export default function() {
	return [ [ "baik", "maupun" ], [ "bukan", "melainkan" ], [ "bukan", "tetapi" ], [ "bukannya", "melainkan" ], [ "bukannya", "tetapi" ],
		[ "tidak", "melainkan" ], [ "tidak", "tetapi" ], [ "tidak hanya", "tetapi juga" ], [ "begitu", "sehingga" ],
		[ "begitu", "sampai" ], [ "demikian", "sehingga" ], [ "demikian", "sampai" ], [ "sedemikian", "sehingga" ],
		[ "sedemikian", "sampai" ], [ "meskipun", "namun" ], [ "biarpun", "namun" ], [ "bukan hanya", "melainkan juga" ],
		[ "sedemikian rupa", "sehingga" ], [ "sebaiknya", "daripada" ], [ "entah", "entah" ], [ "kalau", "maka" ],
		[ "apabila", "maka" ], [ "apa", "atau" ], [ "jangankan", "pun" ], [ "saja", "apalagi" ], [ "apakah", "atau" ] ];
}
